import { Schema } from "@comparaonline/products-schema";

type HasReviewSummary = (product: Schema.ProductListProduct) => boolean;
export const hasReviewSummary: HasReviewSummary = product =>
  Boolean(product.reviews) && product!.reviews!.total > 0 && product!.reviews!.averageValue > 0;
